export enum StyleEditorCommand {
    INIT = "MAE-STYLE-EDITOR_INIT",
    SAVE = "MAE-STYLE-EDITOR_SAVE",
    MOUNTED = "MAE-STYLE-EDITOR_MOUNTED"
}

export interface StyleEditorMessage {
    command: StyleEditorCommand;
}

export interface StyleEditorInitMessage extends StyleEditorMessage {
    command: StyleEditorCommand.INIT;
    url: string;
}

export interface SLDStyle {
    title: string;
    sld: string;
}